import { CenteredCircularProgress } from '../common/CenteredCircularProgress';
import { AutomationDialogContent } from '../Automations/AutomationDialogContent';
import { AutomationFormVariant } from '../../types/enums/AutomationFormVariant';
import { useSelector } from 'react-redux';
import { selectAssignments } from '../../reducers/global/assignmentReducers';
import { selectDefaultCreationEnvironment } from '../pages/environments/environmentsReducer';
import useAutomationApiPerType from '../Automations/useAutomationApiPerType';
import { useEffect } from 'react';
import { AutomationAssignmentsContextProvider } from './AutomationAssignmentsContextProvider';
import { useExpandedMode } from '../pages/configuration-canvas/panels-reserve-space/ReserveSpaceForPanelsCtx';
import { useGetAssignmentFilters } from '../pages/canvas-pages/automationFilters';
import { assignmentsSortOptions } from '../pages/canvas-pages/consts';

export type AssignmentsProps = {
  recordTypesData: RecordTypesData;
  funnelsData: FunnelsData;
  disableCanvasTemplates?: boolean;
  setHoveredItem?: (automationId?: string | undefined) => void;
  goToRoutingHome: () => void;
};

const Assignments = ({
  recordTypesData,
  funnelsData,
  disableCanvasTemplates,
  setHoveredItem,
  goToRoutingHome,
}: AssignmentsProps) => {
  const assignmentRules = useSelector(selectAssignments);
  const crmOrg = useSelector(selectDefaultCreationEnvironment);
  const { onSaveOrCreate, onToggleActivation, onDeleteAutomation, onDeployAutomation } =
    useAutomationApiPerType({ automationVariant: AutomationFormVariant.ASSIGNMENT_RULES });

  const { isExpandedMode } = useExpandedMode();
  const filters = useGetAssignmentFilters();

  useEffect(() => {
    if (assignmentRules?.length === 0 && !isExpandedMode) {
      goToRoutingHome();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignmentRules]);

  if (!assignmentRules) return <CenteredCircularProgress />;

  return (
    <>
      {crmOrg && (
        <AutomationDialogContent
          automations={assignmentRules ?? []}
          onDeleteAutomation={onDeleteAutomation}
          crmOrgId={crmOrg.id}
          onSaveOrCreate={onSaveOrCreate}
          recordTypesData={recordTypesData}
          funnelsData={funnelsData}
          onToggleActivation={onToggleActivation}
          sortOptions={assignmentsSortOptions}
          disableCanvasTemplates={disableCanvasTemplates}
          setHoveredItem={setHoveredItem}
          onDeployAutomation={onDeployAutomation}
          filtersForExpandedMode={filters}
        />
      )}
    </>
  );
};

const AssignmentsWithContext = (assignmentProps: AssignmentsProps) => {
  return (
    <AutomationAssignmentsContextProvider>
      <Assignments {...assignmentProps} />
    </AutomationAssignmentsContextProvider>
  );
};

export default AssignmentsWithContext;
